import React from 'react';

const PDIcn = {
    edit: (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M2 11l2-.5L11 4l-1.5-1.5L3 9l-1 2z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
        </svg>
    ),
    download: (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M7 2v7m0 0l-3-3m3 3l3-3M2 11v1h10v-1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ),
    share: (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <circle cx="3" cy="7" r="1.6" stroke="currentColor" strokeWidth="1.5" />
            <circle cx="11" cy="3.5" r="1.6" stroke="currentColor" strokeWidth="1.5" />
            <circle cx="11" cy="10.5" r="1.6" stroke="currentColor" strokeWidth="1.5" />
            <path d="M4.5 6L9.5 4M4.5 8L9.5 10" stroke="currentColor" strokeWidth="1.5" />
        </svg>
    ),
    gear: (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <circle cx="7" cy="7" r="1.8" stroke="currentColor" strokeWidth="1.5" />
            <path d="M7 1.5v1.5M7 11v1.5M12.5 7H11M3 7H1.5M11 3L10 4M4 10l-1 1M11 11l-1-1M4 4L3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    ),
    more: (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <circle cx="3" cy="7" r="1" fill="currentColor" />
            <circle cx="7" cy="7" r="1" fill="currentColor" />
            <circle cx="11" cy="7" r="1" fill="currentColor" />
        </svg>
    ),
    arrow: (
        <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
            <path d="M2 5.5h7M6 2.5l3 3-3 3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ),
    open: (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M9 3h2v2M11 3L7 7M5 4H4a1 1 0 00-1 1v5a1 1 0 001 1h5a1 1 0 001-1V9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ),
};

export default PDIcn;
